import { Moment } from 'moment';
import { QuestResponseType } from '../Quotation/Quotation.types';

export enum QuestConsolidatedFilterBy {
  manufacturerCode = 'ManufacturerCode',
  sku = 'SKU',
  barCode = 'BarCode',
  description = 'Description',
  manufacturer = 'Manufacturer',
  group = 'Group',
  subGroup = 'SubGroup',
}

export enum QuestConsolidatedReportType {
  analytical = 'ANALYTICAL',
  synthetic = 'SYNTHETIC',
}

export interface QuestConsolidatedRequest {
  responseType: QuestResponseType;
  companiesIds?: string;
  isSynthetic: boolean;
  parts: boolean;
  consumables: boolean;
  hideInventoryAndCorrectionMovimentation: boolean;
  hideInactiveProducts: boolean;
  showPartsWithNoMovement: boolean;
  hideZeroStock?: boolean;
  filterBy?: QuestConsolidatedFilterBy;
  from?: string;
  to?: string;
  filterByIds?: string;
  startDate: string;
  endDate: string;
}

export interface QuestConsolidatedFormValues {
  companiesIds?: number[];
  reportType: QuestConsolidatedReportType;
  parts: boolean;
  consumables: boolean;
  hideInventoryAndCorrectionMovimentation: boolean;
  hideInactiveProducts: boolean;
  showPartsWithNoMovement: boolean;
  filterBy?: QuestConsolidatedFilterBy;
  from?: string;
  to?: string;
  filterByIds?: number[];
  hideZeroStock?: boolean;
  initialDate: Moment;
  finalDate: Moment;
}
